import { useMemo } from 'react';
import { Text } from '@simplywallst/ui-core';
import { LoadingContainer, ContainerWithPlaceHolder } from './styled';
import type { CurrencyISO } from '@/constants/currencies';

import {
  isInsufficientData as checkInsufficientData,
  mapGqlDataToRawData,
} from './hooks/utils';
import useSankeyData from './hooks/useSankeyData';
import { LoadingWarren } from '@simplywallst/ui-core';
import { useCompanyCanonicalUrl } from '@/hooks/useCompany';
import SankeyContent from './SankeyContent';

export const SankeyContainer = () => {
  const canonicalUrl = useCompanyCanonicalUrl();

  const { data: gqlData, status } = useSankeyData({
    canonicalUrl,
  });

  const currencyISO = useMemo(() => {
    return gqlData?.data?.currencyInfo?.reporting_currency_iso as CurrencyISO;
  }, [gqlData?.data?.currencyInfo?.reporting_currency_iso]);

  const rawData = mapGqlDataToRawData(gqlData);
  const isInsufficientData = checkInsufficientData(rawData);

  if (status === 'loading') {
    return (
      <LoadingContainer placeItems="center">
        <LoadingWarren />
      </LoadingContainer>
    );
  }

  if (isInsufficientData || status === 'error') {
    return (
      <ContainerWithPlaceHolder placeItems="center">
        <Text typography="smallStrong">
          Insufficient data to display Revenue & Expenses Breakdown
        </Text>
      </ContainerWithPlaceHolder>
    );
  }
  return <SankeyContent rawData={rawData} currencyISO={currencyISO} />;
};
